module.exports = __webpack_public_path__ + "static/excel-9be01d9248011beeb8261fc455b56f6f.png";